import React from 'react';
import { Picker } from '@bb-ui/react-library/dist/components';
import PropTypes from 'prop-types';

export const LocalePicker = (props) => {
  const { onLocaleSelection } = props;

  return (
    <div className="full-screen-wrapper">
      <Picker
        inputId="picker-demo-default"
        label="Select a Locale"
        className="picker"
        placeholder="Select a Locale"
        onChange={(option) => onLocaleSelection(option)}
        options={[
          { value: 'ar-sa', label: 'Arabic [Saudi Arabia] (ar-SA)' },
          { value: 'cs-cz', label: 'Czech Republic (cz-cz)' },
          { value: 'cy-gb', label: 'Welsh (cy-gb)' },
          { value: 'da-dk', label: 'Danish (da-dk)' },
          { value: 'de-de', label: 'German (de-de)' },
          { value: 'en-au', label: 'English [Australia] (en-au)' },
          { value: 'en-gb', label: 'English [U.K.] (en-gb)' },
          { value: 'en-us-k12', label: 'English [Gradeschool] (en-us-k12)' },
          { value: 'en-us-pro', label: 'English [Professional] (en-us-pro)' },
          { value: 'en-us', label: 'English [U.S.] (en-us)' },
          { value: 'en', label: 'English (en)' },
          { value: 'es-es', label: 'Spanish (es-es)' },
          { value: 'fr-fr', label: 'French (fr-fr)' },
          { value: 'it-it', label: 'Italian (it-it)' },
          { value: 'ja-jp', label: 'Japanese (ja-jp)' },
          { value: 'ko-kr', label: 'Korean (ko-kr)' },
          { value: 'ms-my', label: 'Malay (ms-my)' },
          { value: 'nb-no', label: 'Norweigian [Norway] (nb-no)' },
          { value: 'nl-nl', label: 'Dutch [Netherlands] (nl-nl)' },
          { value: 'pl-pl', label: 'Polish (pl-pl)' },
          { value: 'pt-br', label: 'Portuguese [Brazil] (pt-br)' },
          { value: 'ru-ru', label: 'Russian (ru-ru)' },
          { value: 'sv-se', label: 'Swedish [Sweden] (sv-se)' },
          { value: 'th-th', label: 'Thai (th-th)' },
          { value: 'tr-tr', label: 'Turkish (tr-tr)' },
          { value: 'zh-cn', label: 'Chinese [S] (zh-cn)' },
          { value: 'zh-tw', label: 'Chinese [T] (zh-tw)' },
        ]}
      />
    </div>);
};

LocalePicker.propTypes = {
  onLocaleSelection: PropTypes.func.isRequired
};